import React, { useState } from 'react'
import { useSelector } from 'react-redux'

const ProfileHeader = () => {
  const profileData = useSelector(s => s.ProfileSteps.profileData);
  const profileCompletion = profileData?.profile_completion || 0;

  return (
    <>
      <div className='portfolio-profile-header'>
        <div className="container">
          <div className="progress">
            <div 
              className="progress-bar" 
              role="progressbar" 
              style={{ width: `${profileCompletion}%` }}
              aria-valuenow={profileCompletion} 
              aria-valuemin="0" 
              aria-valuemax="100"
            ></div>
          </div>
          <h2>
            Profile <strong>{profileCompletion}%</strong> complete
            <img src='./svg/star.svg' alt='' />
          </h2>
        </div>
      </div>
    </>
  )
}

export default ProfileHeader
